import { useQuery } from "@tanstack/react-query";
import { getBackendUrl } from "api/common";
import { axiosClient } from "api/http/config";
import { getDate } from "shared/utils/dateTimeUtils";
import { z } from "zod";

const trainSeriesResponseSchema = z.object({
  trainSeries: z.array(z.string()),
});

export const useTrainSeriesRange = (
  fromDate: Date,
  toDate: Date,
  enabled = true,
) => {
  // We can't control Spor's DateRangePicker, so for this invalid state we just use toDate=fromDate.
  const toDateSafe = toDate >= fromDate ? toDate : fromDate;
  return useQuery({
    queryKey: ["trainSeries", fromDate, toDate],
    refetchInterval: 30000, // Backend refreshes its cache every 30s
    enabled,
    queryFn: async ({ signal }) =>
      axiosClient
        .get(
          `${getBackendUrl()}/trainList/trainseries?fromDate=${getDate(fromDate)}&toDate=${getDate(toDateSafe)}`,
          {
            signal,
          },
        )
        .then((res) => trainSeriesResponseSchema.parse(res.data)),
  });
};
